function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 15">
      <path fill="currentColor" d="M20 2l-2-2L7 11 2 6 0 8l7 7z" />
    </svg>
  );
}

export default Icon;
